import {Repository, createRepository} from '@/repositories/Base/Repository'

class FunctionRepository extends Repository {
    endpoint = 'vam/cloud_functions'

    search(params) {
        return this.$axios.get(`${this.endpoint}/list`, {params})
    }
}

export default new FunctionRepository()

export const create = createRepository(FunctionRepository)
